<template>
  <el-dialog
    class="already-ad-modal"
    :modal="false"
    width="500px"
    :close-on-click-modal="false"
    title="引入已有广告"
    :visible.sync="modalVisible"
  >
    <el-input v-model="searchName" style="width: 300px; margin-bottom: 12px" placeholder="请输入广告名称或id" @change="searchAd">
    </el-input>
    <div class="table-wrap">
      <el-table :data="adList" style="width: 100%" @select="selectRow" ref="tableRef" max-height="500px">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="广告名称">
          <template slot-scope="scope">
            {{ scope.row.promotionName }}
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="modalVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmPromotion">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPromotionList_ttV2 } from "@/api/promotion.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      modalVisible: false,
      searchName: "",
      selectData: null,
      adList: [],
      checkList: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
    };
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
    }),
  },

  methods: {
    showModal() {
      this.getList();
      this.modalVisible = true;
    },
    getList() {
      getPromotionList_ttV2({
        page: this.pageData.page,
        pageSize: this.pageData.size,
        name: this.searchName,
        advertiserId: this.adCount,
      }).then((res) => {
        this.adList = res.data.promotionList;
        this.pageData.total = res.data.totalNum;
      });
    },
    searchAd() {
      this.pageData.page = 1;
      this.getList();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    selectRow(selection, row) {
      this.selectData = row;
      this.$refs.tableRef.clearSelection();
      this.$refs.tableRef.toggleRowSelection(row, true);
    },
    confirmPromotion() {
      if (this.selectData) {
        this.modalVisible = false;
        this.$emit("selectOk", this.selectData);
      } else {
        this.$message({
          message: "请选择一条已有广告数据",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.already-ad-modal {
}
</style>
